module.exports = __webpack_public_path__ + "static/img/6.18e2d372.png";